import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { Draggable } from 'react-beautiful-dnd';
import TextCSS from '@Components/Common/Text/Styles';

import { setSelectedProcessId, setChoiceText } from '@Services/Editor';

import TextArea from '@Components/Common/TextArea';
import HoverComponent from '@Components/Common/HoverComponent';

import useHover from '@Hooks/useHover';
import ChoiceProperties from './Property';
import ChoiceShowMoreButton from './ChoiceShowMoreButton';
import AddingChoiceResultButton from './AddingChoiceResultButton';
import Result from './Result';

// eslint-disable-next-line no-unused-vars
const Choice = ({ index, processId, choiceId, text, results, snackBarRef, isProcessTextEmpty, validatedProcess }) => {
  const dispatch = useDispatch();

  const onTextChange = useCallback(
    ({ target: { value } }) => {
      if (value.length > 150) return;
      dispatch(setChoiceText({ processId, choiceId, text: value }));
    },
    [dispatch],
  );

  const handleUpdateSelectedProcessId = useCallback(() => {
    dispatch(setSelectedProcessId({ processId }));
  }, [dispatch, processId]);

  // const [isHovered, setIsHovered] = useState(false);

  // const handleMouseEnter = () => {
  //   setIsHovered(true);
  // };

  // const handleMouseLeave = () => {
  //   setIsHovered(false);
  // };

  const { isHovered, handleMouseEnter, handleMouseLeave } = useHover();

  return (
    <Draggable index={index} draggableId={`${processId}:${choiceId}`}>
      {provided => (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <ChoiceContainer
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
          onMouseEnter={handleMouseEnter}
          onMouseLeave={handleMouseLeave}
        >
          <ChoiceProperties processId={processId} choiceId={choiceId} />

          <ChoiceTextContainer>
            <TextArea
              placeholder="선택지 텍스트를 입력하세요"
              value={text}
              onChange={onTextChange}
              fontCSS={TextCSS.BodyB}
              onFocus={handleUpdateSelectedProcessId}
            />
            {!text && !isProcessTextEmpty && (
              <HoverComponent
                label="선택지를 작성해주세요."
                absolutes={false}
                style={{ position: 'absolute', top: '10px', left: '-36px' }}
                iconColor={({ theme }) => theme.colors.danger}
                align="left"
              />
            )}

            <ChoiceShowMoreButton processId={processId} choiceId={choiceId} />
          </ChoiceTextContainer>
          <ChoiceResultsContainer>
            <Result
              processId={processId}
              choiceId={choiceId}
              results={results}
              choiceIndex={index}
              snackBarRef={snackBarRef}
              isChoiceHovered={isHovered}
              isProcessTextEmpty={isProcessTextEmpty}
              validatedProcess={validatedProcess}
            />
          </ChoiceResultsContainer>
          <AddingChoiceResultButton processId={processId} choiceId={choiceId} results={results} />
        </ChoiceContainer>
      )}
    </Draggable>
  );
};

Choice.propTypes = {
  index: PropTypes.number.isRequired,
  processId: PropTypes.number.isRequired,
  choiceId: PropTypes.number.isRequired,
  text: PropTypes.string.isRequired,
  results: PropTypes.arrayOf(PropTypes.object).isRequired,
};

const ChoiceContainer = styled.div`
  padding: 12px 12px;
  margin-bottom: 8px;
  border-radius: 20px;
  border: 1px solid ${({ theme }) => theme.colors.ui_4};
  position: relative;
`;

const ChoiceResultsContainer = styled.div`
  border-radius: 16px;
  with: 100%;
  background-color: rgba(201, 193, 244, 0.2);
  gap: 0px;
`;

const ChoiceTextContainer = styled.div`
  position: relative;

  display: flex;
  align-items: center;

  margin-bottom: 8px;
`;

export default React.memo(Choice);
